/* eslint-disable react/no-unused-prop-types */
// component is extended and props are used in the inherited class but eslint doesn't recognize it
import * as React from 'react';
import { flatten, isEmpty } from 'lodash';

import MentionCardKeywords from '../mention-card-keywords/MentionCardKeywords';

import { __t, applyTranslations } from 'utils/language';
import { getSanitizedValue, wrapSearchTermsText } from '../utils/mention-card';

import './mention-card-information.scss';

import type { MentionCardModalItem } from 'types';

applyTranslations(require('./mention-card-information.i18n.json'));

type Props = {
  post: MentionCardModalItem,
  maxRowCount?: number,
  isLimitedKeywords?: boolean
};

class MentionCardInformation extends React.PureComponent<Props> {
  getUpdatedSearchTerms(): Array<string> {
    const { post } = this.props;
    const matchedSearchTerms = (post && post.matchedSearchTermsNames) || [];
    const updatedMatchedTerms = matchedSearchTerms.map(str => str.split('+')); // multi-queries have `+` symbol

    return flatten(updatedMatchedTerms);
  }

  wrapSearchTerms(value: string): string {
    const matchedSearchTerms = this.getUpdatedSearchTerms();
    let updatedValue = value;

    matchedSearchTerms.forEach(searchTerm => {
      updatedValue = updatedValue || value;
      updatedValue = wrapSearchTermsText(
        updatedValue,
        searchTerm,
        'mention-card-information__highlighted'
      );
    });

    return updatedValue;
  }

  renderSection(msgKey: string, value: string): React.ReactNode | undefined | null {
    const textWithWrappedValues = this.wrapSearchTerms(value);

    return !isEmpty(value) && (
      <div className="mention-card-information__section">
        <div className="mention-card-information__section-title">
          {__t(`mention_card_information.${msgKey}`)}:
        </div>
        <span dangerouslySetInnerHTML={{ __html: getSanitizedValue(textWithWrappedValues) }} />
      </div>
    );
  }

  renderKeywords(key: 'hashtags' | 'mentions' | 'tags'): React.ReactNode {
    const { post } = this.props;
    const keywords = post && post[key];
    const matchedSearchTerms = this.getUpdatedSearchTerms();
    const prefix = key === 'hashtags' ? '#' : '@';

    return !isEmpty(keywords) && (
      <div className="mention-card-information__section mention-card-information__section--keywords">
        <div className="mention-card-information__section-title">
          {__t(`mention_card_information.label_${key}`)}:
        </div>
        <div className="text-overflow-ellipsis">
          <MentionCardKeywords
            items={keywords}
            matchedSearchTerms={matchedSearchTerms}
            type={key}
            prefix={prefix}
          />
        </div>
      </div>
    );
  }
}

export default MentionCardInformation;
